import React, { useMemo, useState } from 'react';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';
import Tooltip from '@mui/material/Tooltip';
import { NewBeaconExportIcon } from 'src/components/SvgIcons';
import { SlColumn } from 'src/components/BeaconV2Components/Generic/SlColumn';
import { SlDropdownMenu } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/input';
import { SlRow } from 'src/components/BeaconV2Components/Generic/SlRow';
import { OptimizationGridExportModal } from './OptimizationGridExportModal';
import AdvancedSearchRequestBuilder from 'src/components/BeaconV2Components/utils/AdvancedSearchRequestBuilder';

import { BEACON_PRO_RIGHT_CONTENT_WIDTH } from 'src/components/Layout/Beacon/BeaconProLayoutConsts';

export const defaultHeaderIconSpanStyle = {
  width: '24px',
  height: '24px',
  cursor: 'pointer',
  marginLeft: 'auto',
  marginBottom: 'auto'
};
export const OptimizationGridHeader = ({
  options,
  setOption,
  selectedOption
}: {
  options: {
    displayName: string;
    name: string;
  }[];
  setOption: (option: 'target' | 'campaign' | 'manual') => void;
  selectedOption: string;
}) => {
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const entityType = useMainEntityType();
  const indexName = 'adOptimizationHistory';

  const newOptions = useMemo(() => {
    if (options.length === 0) {
      return [];
    }

    return options.map((field) => ({
      id: field.name,
      label: field.displayName,
      ...field
    }));
  }, [options]);

  const selectedOptionName = useMemo(() => {
    return newOptions.find((o) => o.id === selectedOption);
  }, [newOptions, selectedOption]);

  return (
    <SlColumn
      widths="full"
      style={{
        paddingBottom: '32px',
        paddingTop: '32px',
        maxWidth: BEACON_PRO_RIGHT_CONTENT_WIDTH
      }}
    >
      <div
        style={{
          width: '100%',
          display: 'flex'
        }}
      >
        <SlRow
          style={{
            gap: '5px',
            paddingBottom: `0px`
          }}
          verticalPosition="center"
        >
          <SlDropdownMenu
            defaultLabel={selectedOptionName.label}
            onChange={(s) => {
              setOption(s.id as any);
            }}
            selectedId={selectedOption}
            buttonVariant="title"
            options={newOptions}
          />
        </SlRow>
        <Tooltip title="Export" placement="top">
          <span style={defaultHeaderIconSpanStyle}>
            {entityType === 'adCampaign' && (
              <NewBeaconExportIcon
                width="24px"
                height="24px"
                id="export"
                onClick={() => {
                  setIsExportModalOpen(true);
                }}
              />
            )}
          </span>
        </Tooltip>
        <OptimizationGridExportModal
          open={isExportModalOpen}
          onClose={() => setIsExportModalOpen(false)}
          options={newOptions}
          builderProps={{
            indexName,
            fields: [],
            groupBy: selectedOption,
            requestId: 'adOptimizationHistory',
            buildRequest: (builder: AdvancedSearchRequestBuilder) => {
              return builder
                .removeConditionTermFilters((builderFilter) => builderFilter.fieldName === 'categoryId')
                .setProcessDocuments(true)
                .setDoAggregation(false)
                .setReturnDocuments(true);
            }
          }}
        />
      </div>
    </SlColumn>
  );
};
